export enum Situacao {
  ATIVO = <any> 'ATIVO',
  INATIVO = <any> 'INATIVO'
}
